import React from "react";

export default function ActionButton({
  children,
  onClick,
  disabled = false,
  tone = "default",
  style = {},
  type = "button",
}) {
  const tones = {
    default: {
      background: "#ffffff",
      border: "1px solid #dbe4ee",
      color: "#0f172a",
    },
    primary: {
      background: "#2563eb",
      border: "1px solid #2563eb",
      color: "#ffffff",
    },
    success: {
      background: "#16a34a",
      border: "1px solid #16a34a",
      color: "#ffffff",
    },
    warning: {
      background: "#f59e0b",
      border: "1px solid #f59e0b",
      color: "#ffffff",
    },
    danger: {
      background: "#dc2626",
      border: "1px solid #dc2626",
      color: "#ffffff",
    },
  };

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      style={{
        borderRadius: 10,
        padding: "8px 12px",
        fontWeight: 900,
        fontSize: 12,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        transition: ".15s",
        ...(tones[tone] || tones.default),
        ...style,
      }}
    >
      {children}
    </button>
  );
}